function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_67809",
  "data-name": "Group 67809",
  transform: "translate(6.319 3.665)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_52312",
  "data-name": "Path 52312",
  d: "M14.842,7.52,9.47,11.543",
  transform: "translate(-4.878 -2.924)",
  fill: "none",
  stroke: "#323232",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_52313",
  "data-name": "Path 52313",
  d: "M17.526,4.835a2.689,2.689,0,1,1-3.8,0,2.689,2.689,0,0,1,3.8,0",
  transform: "translate(-3.758 -4.047)",
  fill: "none",
  stroke: "#323232",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_52314",
  "data-name": "Path 52314",
  d: "M14.842,17.463,9.47,13.44",
  transform: "translate(-4.878 -1.011)",
  fill: "none",
  stroke: "#323232",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_52315",
  "data-name": "Path 52315",
  d: "M17.526,16.677a2.689,2.689,0,1,1-3.8,0,2.689,2.689,0,0,1,3.8,0",
  transform: "translate(-3.758 -0.219)",
  fill: "none",
  stroke: "#323232",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_52316",
  "data-name": "Path 52316",
  d: "M10.586,10.757a2.686,2.686,0,1,1-3.8,0,2.686,2.686,0,0,1,3.8,0",
  transform: "translate(-6 -2.133)",
  fill: "none",
  stroke: "#323232",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_52317",
  "data-name": "Path 52317",
  d: "M0,0H28.377V28.377H0Z",
  fill: "none"
});

function SvgShare1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "share.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.377,
    height: 28.377,
    viewBox: "0 0 28.377 28.377",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare1);
export default __webpack_public_path__ + "static/media/share.1.d2bc3d90.svg";
export { ForwardRef as ReactComponent };